import { Raycaster, Vector2 } from 'three'
import { LHFEventDispatcher } from '../../com/LHFEventDispatcher'
import { PanoEvent } from '../events/PanoEvents'
class MarkerRaycaster extends LHFEventDispatcher {
  constructor(dom_, camera_) {
    super()
    this.domContainer = dom_
    this.camera = camera_
    this.markers = []
    this.raycaster = new Raycaster()
    this.downPoint = new Vector2()
    this.movePoint = new Vector2()
    this.createEvents()
  }

  /**     * 创建事件     */
  createEvents() {
    this.domContainer.addEventListener('mousedown', this._mouseDownHandler)
    this.domContainer.addEventListener('touchstart', this._touchStartHandler)
    this.domContainer.addEventListener('touchmove', this._touchMoveHandler)
    this.domContainer.addEventListener('mouseup', this._mouseUpHandler)
    this.domContainer.addEventListener('touchend', this._touchEndHandler)
  }

  /**
   * 添加响应标记
   * @param markers_
   */
  addMarkers(markers_) {
    this.markers.push(...markers_)
    // console.log('marker length:', this.markers, this)
  }

  /**
   * 清除标记
   */
  clearMarkers() {
    this.markers = []
  }

  /**
   * 鼠标按下事件
   * @param e
   * @private
   */
  _touchStartHandler = e => {
    console.log('touch start')
    let rect_ = this.domContainer.getBoundingClientRect()
    let touch = e.touches[0]
    if (!touch) return
    let vec = new Vector2(touch.clientX, touch.clientY)
    vec.x -= rect_.left
    vec.y -= rect_.top
    // this.downPoint.set(e.clientX, e.clientY);
    this.downPoint.copy(vec)
    this.movePoint.copy(vec)
  }

  _touchMoveHandler = e => {
    let touch = e.touches[0]
    if (!touch) return
    let upVec2_ = new Vector2(touch.clientX, touch.clientY)
    let rect_ = this.domContainer.getBoundingClientRect()
    upVec2_.x -= rect_.left
    upVec2_.y -= rect_.top
    this.movePoint.copy(upVec2_)
  }

  /**
   * 鼠标抬起
   * @param e
   * @private
   */
  _touchEndHandler = e => {
    console.log('touch end')
    let upVec2_ = this.movePoint.clone()
    let distance_ = upVec2_.distanceTo(this.downPoint)
    /**         * 鼠标按下与抬起的距离较远,不激活点击         */
    if (distance_ > 5) return
    let rect_ = this.domContainer.getBoundingClientRect()
    let viewVec2_ = new Vector2()
    viewVec2_.x = (upVec2_.x / rect_.width) * 2 - 1
    viewVec2_.y = -(upVec2_.y / rect_.height) * 2 + 1
    this.intersectMesh(viewVec2_)
  }

  /**
   * 鼠标按下事件
   * @param e
   * @private
   */
  _mouseDownHandler = e => {
    let rect_ = this.domContainer.getBoundingClientRect()
    let vec = new Vector2(e.clientX, e.clientY)
    vec.x -= rect_.left
    vec.y -= rect_.top
    // this.downPoint.set(e.clientX, e.clientY);
    this.downPoint.copy(vec)
  }

  /**
   * 鼠标抬起
   * @param e
   * @private
   */
  _mouseUpHandler = e => {
    let upVec2_ = new Vector2(e.clientX, e.clientY)
    let rect_ = this.domContainer.getBoundingClientRect()
    upVec2_.x -= rect_.left
    upVec2_.y -= rect_.top
    let distance_ = upVec2_.distanceTo(this.downPoint)
    /**         * 鼠标按下与抬起的距离较远,不激活点击         */
    if (distance_ > 5) return
    let viewVec2_ = new Vector2()
    viewVec2_.x = (upVec2_.x / rect_.width) * 2 - 1
    viewVec2_.y = -(upVec2_.y / rect_.height) * 2 + 1
    this.intersectMesh(viewVec2_)
  }

  /**     * 选中     */
  intersectMesh(vec2_) {
    this.raycaster.setFromCamera(vec2_, this.camera)
    let hotObjects = this.markers
    let intersect_ = this.raycaster.intersectObjects(hotObjects, false)
    if (intersect_.length < 1) {
      return
    }
    let first_ = intersect_[0].object
    if (!first_.userData) return
    if(!first_.visible) return;
    this.dispatchEvent({
      type: PanoEvent.MARKER_SELECT,
      data: first_.userData
    })
  }
}

export { MarkerRaycaster }



// WEBPACK FOOTER //
// ./src/webgl/control/MarkerRaycaster.js